import IEntity from "./Entity";
import IUser from "./User";
import IInstallment from "./Installment";
import { Dayjs } from "dayjs";
import IPlan from "./Plan";
import IPaymentMethod from "./PaymentMethod";

export default interface ISubscription extends IEntity {
	user?: IUser;
	value?: string | any;
	discount?: string | any;
	installment?: string;
	installmentInterval?: string;
	description?: string;
	status?: SubscriptionStatus | any;
	plan?: string | IPlan;
	paymentMethod?: string | IPaymentMethod;
	firstPayment?: Dayjs;
	installments?: IInstallment[];
}

export enum SubscriptionStatus {
	pending = 0,
	enabled = 1
}
